import { Checkbox as CheckboxAntd } from "antd";
import { CheckboxProps, CheckboxRef } from "antd/lib";
import { forwardRef } from "react";

import cn from "@/utils/tailwind/cn";

const FormCheckbox = forwardRef<CheckboxRef, CheckboxProps>(
  ({ className, ...props }, ref) => (
    <CheckboxAntd
      className={cn(
        "[&_.ant-checkbox-indeterminate_.ant-checkbox-inner]:!bg-gray-400",
        "[&:hover_.ant-checkbox-indeterminate_.ant-checkbox-inner]:!border-gray-500",
        "[&_.ant-checkbox-indeterminate_.ant-checkbox-inner]:!border-gray-400",
        "[&_.ant-checkbox-indeterminate_.ant-checkbox-inner:after]:rounded-[1px]",
        "[&_.ant-checkbox-indeterminate_.ant-checkbox-inner:after]:bg-white",
        "[&_.ant-checkbox-indeterminate_.ant-checkbox-inner:after]:h-0.5",
        className,
      )}
      ref={ref}
      {...props}
    />
  ),
);

export default FormCheckbox;
